"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostBookingExceptionString = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const ExceptionReasonsContext_1 = require("./ExceptionReasonsContext");
const usePostBookingExceptionString = (exception) => {
    const { exceptionReasons, parties } = (0, ExceptionReasonsContext_1.useExceptionReasonsState)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    if (!exception) {
        return [];
    }
    const getExceptionReason = (reasonId) => {
        if (reasonId && exceptionReasons) {
            return exceptionReasons[reasonId] ? exceptionReasons[reasonId]?.name : translate(reasonId);
        }
        return undefined;
    };
    const getExceptionResponsible = (responsibleId) => {
        if (responsibleId && parties[responsibleId]) {
            return parties[responsibleId]?.name;
        }
        return undefined;
    };
    const toActivityFieldValue = (fieldValue) => {
        const defaultActivityFieldValue = '--';
        return fieldValue || defaultActivityFieldValue;
    };
    const { reasonId, responsiblePartyId, additionalInfo } = exception;
    const reason = getExceptionReason(reasonId ?? '');
    const party = getExceptionResponsible(responsiblePartyId ?? '');
    return [
        ['Change Reason', toActivityFieldValue(reason)],
        ['Responsible Party', toActivityFieldValue(party)],
        ['Additional Information', toActivityFieldValue(additionalInfo ?? '')],
    ];
};
exports.usePostBookingExceptionString = usePostBookingExceptionString;
//# sourceMappingURL=getPostBookingExceptionString.js.map